export default __webpack_public_path__ + "static/media/territorio-astronaut.d0602465.png";